/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Line } from "react-chartjs-2";
import { useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Draggable from "react-draggable";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { Paper, Button } from "@mui/material";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);
function PaperComponent(props) {
  return (
    <Draggable
      handle='#draggable-dialog-title'
      cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
function exponentialSmoothing(years, costs, alpha) {
  // Initialize the forecast with the last known cost
  let forecast = costs[costs.length - 1];

  // Apply Exponential Smoothing to predict the next year's cost
  for (let i = 0; i < years.length; i++) {
    forecast = alpha * costs[i] + (1 - alpha) * forecast;
  }

  // Return the forecast for the following year
  return forecast;
}
export default function LineChart() {
  const allAssets = useSelector((state) => state.assets);
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const [labelName, setLabelName] = React.useState("");
  const handleClose = () => {
    setOpen(false);
    setLabelName("");
  };
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);
  // const [yearData, setYearData] = React.useState([]);

  const dataToShow = [...allAssets];
  const [dataShow, setData] = React.useState([]);
  React.useEffect(() => {
    if (labelName !== "") {
      handleModal();
    }
  }, [labelName]);
  // Example usage:
  function handleModal() {
    const res = dataToShow.filter((asset) => {
      return asset.purchase_date.includes(labelName);
    });

    setData(res);
    handleClickOpen();
  }
  const columns = Object.keys(dataShow[0] || {})
    .filter((key) => key !== "id")
    .map((key) => ({
      field: key,
      headerName: key,
      minWidth: 170,
      align: "left",
    }));

  const yearData = useSelector((state) => state.yearData);
  let year = [];
  let cost = [];

  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 2,
  });
  yearData.map((data) => {
    // eslint-disable-next-line no-sequences
    return year.push(data._id), cost.push(data.cost);
  });
  let newCost = [];
  cost.forEach((cost) => {
    let AllnewCost = currencyFormatter.format(cost);
    newCost.push(AllnewCost);
  });

  const needed_year = new Date().getFullYear() + 1;
  const lastFive = cost.slice(-5);

  const fiveyear = year.slice(-5);
  const next = exponentialSmoothing(fiveyear, lastFive, 0.8);
  year.push(needed_year);
  cost.push(next);

  // const fixedArray = cost?.map((value) => value?.toFixed(2) * 1);
  const fixedArray =
    cost.length > 0 ? cost?.map((value) => value?.toFixed(2) * 1) : [];

  // Updated the dataset with 'backgroundColor' function to conditionally set colors
  const data = {
    labels: year,
    datasets: [
      {
        // fill: true,
        label: "Cost of assets",
        data: fixedArray,
        borderColor: `${mode === "dark" ? "#0883FF" : "#3D4F58"}`,
        backgroundColor: "#3D4F58",

        pointRadius: 3, // Increase the point size for visibility
        tension: 0.3,
        datalabels: {
          display: true,
          backgroundColor: "transparent",
          anchor: "end",
          align: "end",
          font: {
            size: 14,
          },
        },
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        // position: "top",
        display: true,
      },
      title: {
        display: true,
        text: "Acquisitions per year",
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const clickedElementIndex = elements[0].index;
        const labelName = data.labels[clickedElementIndex];
        setLabelName(labelName);
      }
    },
  };
  return (
    <div style={{ marginTop: "10px", padding: "10px", borderRadius: "25px" }}>
      <Line
        style={{
          backgroundColor: `${mode === "dark" ? "#101418" : "#D7DED0"}`,
          borderRadius: "20px",
          border: "1px solid #a5aba0",
          cursor: "pointer",
        }}
        height={300}
        options={options}
        data={data}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'>
        <DialogTitle style={{ cursor: "move" }} id='draggable-dialog-title'>
          {labelName} Assets
        </DialogTitle>
        <DialogContent>
          <Paper>
            <DataGrid
              columns={columns}
              getRowId={(row) => row.id}
              rows={dataShow}
              slots={{ toolbar: GridToolbar }}
              style={{ height: "50vh" }}
              disableRowSelectionOnClick
            />
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
